import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

import themeable from 'zignal-landscape/lib/themeable';
import Button from 'zignal-landscape/lib/Button';
import ButtonGroup from 'zignal-landscape/lib/ButtonGroup';
import Input from 'zignal-landscape/lib/Input';
import Label from 'zignal-landscape/lib/Label';
import Link from 'zignal-landscape/lib/Link';
import Modal from 'zignal-landscape/lib/Modal';
import ModalHeader from 'zignal-landscape/lib/ModalHeader';
import ModalBody from 'zignal-landscape/lib/ModalBody';
import ModalFooter from 'zignal-landscape/lib/ModalFooter';
import Radio from 'zignal-landscape/lib/Radio';
import Select from 'zignal-landscape/lib/Select';

import * as actions from './AddToGroupModal.ducks';

const mapStateToProps = (
  (state) => ({
    isAddToGroupModalOpen: state.BotIntelligence.Page.isAddToGroupModalOpen,
    selectedTopClustersByVolume: state.BotIntelligence.Page.selectedTopClustersByVolume,
    addTo: state.BotIntelligence.AddToGroupModal.addTo,
    groups: state.BotIntelligence.AddToGroupModal.groups,
    newGroupName: state.BotIntelligence.AddToGroupModal.newGroupName,
    selectedCampaign: state.BotIntelligence.AddToGroupModal.selectedCampaign,
    selectedGroup: state.BotIntelligence.AddToGroupModal.selectedGroup
  })
);

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

class AddToGroupModal extends React.Component {

  constructor(props) {
    super(props);

    this.onCloseModal = this.onCloseModal.bind(this);
    this.onSelectedCampaign = this.onSelectedCampaign.bind(this);
    this.onAddToOptionChange = this.onAddToOptionChange.bind(this);
    this.onInputNameGroupChange = this.onInputNameGroupChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { defaultCampaign, fetchGroups, isAddToGroupModalOpen, setSelectedCampaign } = this.props;
    if (!prevProps.isAddToGroupModalOpen && isAddToGroupModalOpen) {
      setSelectedCampaign(defaultCampaign);
      // TODO: implement a spinner or at least disabled submit until call has finished.
      fetchGroups();
    }
  }

  onCloseModal() {
    this.props.clearModalForm();
    this.props.setAddToGroupModalVisibility(false);
  }

  onSelectedCampaign(el) {
    this.props.setSelectedCampaign(el);
    this.props.fetchGroups();
    // TODO: write a 'reset' state.
    this.props.setAddToOption('existingGroup');
  }

  onAddToOptionChange({ target: { value } }) {
    this.props.setAddToOption(value);
  }

  onInputNameGroupChange({ target: { value } }) {
    this.props.setNewGroupNameValue(value);
  }

  render() {
    const {
      styles,
      addTo,
      groupFieldsDestination,
      campaigns,
      selectedTopClustersByVolume,
      groups,
      isAddToGroupModalOpen,
      newGroupName,
      saveToGroup,
      selectedCampaign,
      selectedGroup,
      setSelectedGroup,
    } = this.props;

    let topBodyText = '';
    let dynamicGroupTypeText = '';
    if (groupFieldsDestination.length > 1) {
      const groupTypeCounts = {};
      const groupTargetLabelCounts = {};

      groupFieldsDestination.forEach(gfd => {
        const groupType = gfd.type === 'channel' ? 'author' : gfd.type;
        const groupTypeCount = groupTypeCounts[groupType] || 0;
        groupTypeCounts[groupType] = groupTypeCount + 1;

        const targetLabel = gfd.targetLabel;
        const groupTargetLabelCount = groupTargetLabelCounts[targetLabel] || 0;
        groupTargetLabelCounts[targetLabel] = groupTargetLabelCount + 1;
      });

      const groupTypeText = [];
      Object.keys(groupTypeCounts).forEach((key) => {
        const count = groupTypeCounts[key];
        const name = `${key}${count > 1 ? 's' : ''}`;
        groupTypeText.push(`${count} ${name}`);
      });
      dynamicGroupTypeText = groupTypeText.join(', ').replace(/,([^,]*)$/, ' and$1');
      dynamicGroupTypeText = ` Considering ${dynamicGroupTypeText} towards your workspace group limits.`;

      const groupTargetLabelText = [];
      Object.keys(groupTargetLabelCounts).forEach((key) => {
        const count = groupTargetLabelCounts[key];
        const name = `${key}${count > 1 ? 's' : ''}`;
        groupTargetLabelText.push(`${count} unique ${name}`);
      });
      const dynamicGroupTargetLabelText = groupTargetLabelText.join(', ').replace(/,([^,]*)$/, ' and$1');

      topBodyText = `Add ${dynamicGroupTargetLabelText} `;
    } else if (groupFieldsDestination.length === 1) {
      topBodyText = `Add your selection of ${groupFieldsDestination[0].targetLabel} `;
    } else {
      topBodyText = `Add your selection${selectedTopClustersByVolume.length > 1 ? 's' : ''} `;
    }

    topBodyText += 'to an existing group or a new one.' + dynamicGroupTypeText;

    const isSubmitEnabled = (addTo === 'newGroup' && !isEmpty(newGroupName))
      || (addTo === 'existingGroup' && !isEmpty(selectedGroup));

    const groupLimit = get(selectedCampaign, 'groupLimit', 0);
    const hasSelectedCampaignReachedGroupLimit = !groupLimit || (groupLimit <= groups.length);

    return (
      <div >
        <Modal
          isOpen={isAddToGroupModalOpen}
          size="medium"
          onEscapePress={this.onCloseModal}
          onBackdropClick={this.onCloseModal}
        >
          <ModalHeader hideCloseButton={false} onClose={this.onCloseModal}>
            Add to or Create New Group
          </ModalHeader>
          <ModalBody>
            <div className={styles.bodyTopSpan}>
              <b data-cy="add-to-group-details">{topBodyText}</b>
            </div>
            {campaigns.length > 1 &&
              <div className={styles.campaignSection}>
                <Label>Choose a Workspace</Label>
                <Select
                  key="choose-campaign-dropdown"
                  id="choose-campaign-dropdown"
                  options={campaigns}
                  value={selectedCampaign}
                  onChange={this.onSelectedCampaign}
                  placeholder="Select a Workspace"
                  isSearchable
                  selectStyles={{ singleValue: base => ({ ...base, padding: 0, lineHeight: 'inherit', color: 'inherit' }) }}
                />
              </div>
            }
            <div className={styles.addToSection}>
              <Radio
                id="existingGroup"
                name="addTo"
                value="existingGroup"
                checked={addTo === 'existingGroup'}
                onChange={this.onAddToOptionChange}
              />
              <Label htmlFor="existingGroup" inline>Add to an Existing Group</Label>
              <Select
                key="add-to-existing-group"
                id="add-to-existing-group"
                options={groups}
                value={selectedGroup}
                onChange={setSelectedGroup}
                disabled={addTo !== 'existingGroup'}
                selectStyles={{ singleValue: base => ({ ...base, padding: 0, lineHeight: 'inherit', color: 'inherit' }) }}
              />
            </div>

            <div className={styles.createSection}>
              <Radio
                id="newGroup"
                name="addTo"
                value="newGroup"
                checked={addTo === 'newGroup'}
                onChange={this.onAddToOptionChange}
                disabled={hasSelectedCampaignReachedGroupLimit}
              />
              <Label
                htmlFor="newGroup"
                inline
                disabled={hasSelectedCampaignReachedGroupLimit}
              >
                Create a New Group
              </Label>
              <Input
                id="newGroupInput"
                placeholder="Name the group"
                value={newGroupName}
                onChange={this.onInputNameGroupChange}
                disabled={addTo !== 'newGroup' || hasSelectedCampaignReachedGroupLimit}
              />
              {
                hasSelectedCampaignReachedGroupLimit &&
                <p className={styles.groupLimitReachedMessage}>You have reached your Group limit</p>
              }
            </div>
          </ModalBody>

          <ModalFooter>
            <ButtonGroup align="right">
              <Link linkType="cancel" onClick={this.onCloseModal}>Cancel</Link>
              <Button
                id="saveGroup"
                buttonStyle="positive"
                disabled={!isSubmitEnabled}
                onClick={saveToGroup}
              >
                Done
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

AddToGroupModal.propTypes = {
  styles: PropTypes.object,
  isAddToGroupModalOpen: PropTypes.bool,
  addTo: PropTypes.string,
  fetchGroups: PropTypes.func,
  groups: PropTypes.array,
  newGroupName: PropTypes.string,
  selectedGroup: PropTypes.object,
  selectedTopClustersByVolume: PropTypes.array,
  selectedCampaign: PropTypes.object,
  // passed by parent
  groupFieldsDestination: PropTypes.array,
  campaigns: PropTypes.array,
  defaultCampaign: PropTypes.object,
  saveToGroup: PropTypes.func,
  setAddToGroupModalVisibility: PropTypes.func,
  // actions
  clearModalForm: PropTypes.func,
  setAddToOption: PropTypes.func,
  setAddToGroupOption: PropTypes.func,
  setSelectedCampaign: PropTypes.func,
  setSelectedGroup: PropTypes.func,
  setNewGroupNameValue: PropTypes.func,
};

AddToGroupModal.defaultProps = {
  groupFieldsDestination: [],
  groups: [],
  selectedTopClustersByVolume: [],
  campaigns: []
};

export default connect(mapStateToProps, actions, mergeProps)(themeable(AddToGroupModal));
